import { Checkbox, Form, Select, Spin } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Button from '../../../components/Button/Button';
import FileInput from '../../../components/FileInput/FileInput';
import Input from '../../../components/Input/Input';
import { editClub } from '../../../service/clubs';
import { uploadClubImage } from '../../../service/files';
import { editClubGenres, getAllGenres, getClubGenres } from '../../../service/genres';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';

import { useUserStore } from '../../../store/useUser';
import styles from './EditClub.module.scss';
import { FileFormItem } from '../../../components/FormItem/FormItem';
import ImageInput from '../../../components/ImageInput/ImageInput';
import useHeader from '../../../hooks/useHeader';

const { Option } = Select;

const EditClub = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)

  const setClub = useUserStore(state => state.setClub)
  const userId = useUserStore(state => state.id)
  const club = useUserStore(state => state.club)

  
  const {data: clubGenres} = useQuery(
    ['club-genres'],
    () => getClubGenres(club?.id),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data: genres} = useQuery(
    ['genres'],
    () => getAllGenres(),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: 'Configurações do clube' });

  useEffect(() => {
    if (!club) return;

    form.setFields([
      { name: 'inappropriate', value: club.inappropriate },
      { name: 'isPrivate', value: club.isPrivate },
      { name: 'limitUsers', value: club.limitUsers },
      { name: 'city', value: club.city },
      { name: 'description', value: club.description },
    ])
  }, [club, form])

  useEffect(()=>{
    if(!clubGenres?.length) return;
    form.setFields([
      {name: 'genres', value: clubGenres},
    ])

  }, [form, clubGenres])
  
  const onFinish = async () => {
    if(loading) return;

    setLoading(true);

    const payload = form.getFieldsValue();

    payload.userId = userId

    const {error, success} = await editClub(club?.id, payload, userId);

    if(error) {
      setLoading(false);
      return createErrorNotification(error);
    }
    
    let newGenres: number[] = [];

    if (payload.genres) {
      newGenres = payload.genres.map(genre => {
        if (typeof genre === 'number') return genre

        return genre?.id
      })

      await editClubGenres(club?.id, payload.genres)
    }

    delete payload.genres

    if(payload.file || payload.docRules){
      const {error: errorFile } = await uploadClubImage(club.id, payload)
      if(errorFile)
        createErrorNotification(errorFile)
    }

    setClub({...payload, id:club?.id})

    setLoading(false);

    createSuccessNotification('Clube Atualizado');
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
        <Spin spinning={loading}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical" 
              form={form}
              onFinish={onFinish}
              id="formLogin" 
              className={styles.FormContainer}
            >
              <h2 className={styles.title}>Editar clube</h2>
              <FormItem
                label="Nome"
                name="name"
                initialValue={club?.name}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, digite um nome.',
                  },
                  {
                    max: 50,
                    message: 'Nome deve ter entre 1 e 50 caracteres.',
                  }
                ]}
                required
              >
                <Input style={styles.input} />
              </FormItem>
              <FormItem
                label="Descrição"
                name="description">
                <Input style={styles.input} />
              </FormItem>
              <FormItem
                label="É Privado?"
                name="isPrivate"
                tooltip={{ title: "Selecione se desejar que o clube seja privado." }}>
                  <Checkbox defaultChecked={!club.isPrivate}
                            className={styles.isPrivate} 
                            onChange={event => form.setFields([{name: 'isPrivate', value: event.target.checked}])}>          
                    Esse clube é privado.
                  </Checkbox>
              </FormItem>
              <FormItem
                label="Limite de membros"
                name="limitUsers"
                tooltip={{ title: "Número máximo de membros permitidos. Caso não queira, não preencha!" }}>
                <Input type='number' style={styles.input} />
              </FormItem>
              <FormItem
                label="Gêneros Literários do Clube"
                name="genres">
                <Select
                  style={{width: '100%'}}
                  mode="multiple">
                  { 
                    genres?.map(genre => {
                      return <Option key={genre.id} value={genre.id}>{genre.content}</Option>
                    })
                  }
                </Select>
              </FormItem>
              <FileFormItem
                name="file"
                label="Foto do clube"
                >
                <ImageInput 
                  accept="image/*"
                  onChangeFile={(file)=>{
                    form.setFields([
                      {name: 'file', value: file},
                    ]);
                
                    form.validateFields(['file']);
                  }}
                />
              </FileFormItem>
              <FileFormItem
                name="docRules"
                label="Regras do clube">
                <FileInput 
                  accept=".doc,.docx,.pdf,.txt"
                  onChangeFile={(file)=>{
                    form.setFields([
                      {name: 'docRules', value: file},
                    ]);
                
                    form.validateFields(['docRules']);
                  }}
                />
              </FileFormItem>
              <Spin spinning={loading}>
                <Button submit style={styles.button}>Editar clube</Button>
              </Spin>
            </Form>
          </div>
        </Spin>
      </div>
    </div>
  )
}

export default EditClub;